export enum ReportOrder {
  ASC = 0,
  DESC = 1,
}
export enum FileType {
  FILE = 0,
  DIRECTORY = 1,
  SYMLINK_FILE = 2, // 文件的链接|快捷方式
  SYMLINK_DIRECTORY = 3, // 目录的链接|快捷方式
  SYMLINK_UNKNOWN = 4,
}
export enum TaskStatus {
  NONE = 0,
  INCORRECT_PASSWORD = 1,
  TIMEOUT = 2,
  DISCONNECTING = 3,
  DISCONNECTED = 4,
  CONNECTING = 5,
  CONNECTION_FAILED = 6,
  INTERRUPTED = 7,
  WAIT_BROWSING = 8,
  WAIT_PASSWORD = 9,
  LOCAL_FILE_UNWRITEABLE = 10,
  COULD_NOT_START = 11,
  TRANSFERRING = 12,
  CREATING_DIR = 13,
  FILE_NOT_EXIST = 14,
  SERVER_DISK_NOSPACE = 15,
  CLIENT_DISK_NOSPACE = 16,
  DOWNLOAD_REPETITION = 17,
}
export enum FileDialogType {
  NONE = 0, // 不弹窗
  FILE = 1, // 单个文件
  DIRECTORY = 2, // 单个文件夹
  FILES = 3, // 多个文件
  DIRECTORIES = 4, // 多个文件夹
  ANY = 5, // 任何
}
export enum TransferType {
  NONE = 0, // 文件浏览或其他不需要实时上报数据的
  UPLOADING = 1, // 正在上传
  DOWNLOADING = 2, // 正在下载
  UPLOAD_FAILD = 3, // 上传失败
  DOWNLOAD_FAILD = 4, // 下载失败
  UPLOADED = 5, // 已上传
  DOWNLOADED = 6, // 已下载
}
export enum TaskOperation {
  START = 0,
  PAUSE = 1,
  STOP = 2,
  REMOVE = 3,
  START_ALL = 4,
  PAUSE_ALL = 5,
  STOP_ALL = 6,
  REMOVE_ALL = 7,
}
export enum FullPath {
  OFF = 0, // 关闭
  ON = 1, // 自动创建层级目录
}
export interface Progress {
  id: number;
  name: string; // 仅文件名
  type: FileType; // 文件类型
  size: number; // 文件总大小，不是传输的大小
  from: string; // 文件名fullname
  to: string; // 文件名fullname
  speed: number; // 传输速度(byte/s)
  bytes: number; // 已经传输了多少字节
  progress: number; // 传输的进度(%)   0.99 = 99%，精确到小数2为
  remain: number; // 剩余时间(秒s)
  duration: number; // 传输耗时，不算暂停or中断的时间
  time: string; // 传输完成/传输失败的时间
  paused: number; // 1 = yes, 0 = no 传输是否暂停
  status: TaskStatus; // 传输状态
  index?: number; // 对应当前传输队列中的index
}
export interface NetStatus {
  connected: number; // 是否连接，yes = 1 | no = 0
  uploadSpeed: number; // 上传总速度(Byte/s)，由UI自己转换单位
  downloadSpeed: number; // 下载总速度(Byte/s)， 由UI自己转换单位
  lost: number; // 丢包率，这里的返回值为万分之X, 例如返回值为100, 则表明丢包率是万分之100即1%;
  delay: number; // 时延(ms)，小于0, 表示获取失败，等于0的场景是RTT采样还没有成功
  accler: number; // 是否加速, yes = 1 | no = 0
}
export interface TotalCount {
  uploading: number; // 正在上传总数
  downloading: number; // 正在下载总数
  uploadFaild: number; // 传输失败总数
  downloadFaild: number; // 传输失败总数
  uploaded: number; // 已完成上传总数
  downloaded: number; // 已完成下载总数
  uploadActive: number; // 正在上传个数
  downloadActive: number; // 正在下载个数
}
export interface Preference {
  downloadDir: string; // 默认下载的位置，为空时表示系统下载目录
  uploadTaskCount: number; // 同时上传的最大任务数，默认2，最大支持到10
  downloadTaskCount: number; // 同时下载的最大任务数，默认2，最大支持到10
  // enableSpeedLimit: number // 是否启用速度限制，yes = 1, no = 0; 默认=0(废弃)
  // uploadSpeed: number // 最大上传速度(Byte/s)，默认为0，表示最大(废弃)
  // downloadSpeed: number // 最大下载速度(Byte/s)，默认为0，表示最大(废弃)
  outbound: number; // 客户端出口带宽(bit/s)，默认为0，自动调节
  inbound: number; // 客户端入口带宽(bit/s) ，默认为0，自动调节
  compression: number; // 是否启用压缩功能，yes = 1, no = 0; 默认= 1
  autoSpeedTest: number; // 启动自动测速，默认启动=1，不自动测速=0
}
export interface ServerInfo {
  host?: string;
  port?: string;
  proxyHost?: string;
  proxyPort?: string;
  clientVersion: string;
  protocolVersion: string;
  server5Port?: number;
  server5SSLPort?: number;
  renderbusProxyPort: number;
  tcpEnable?: number;
  tcpDelay?: number;
  webServerIp?: string;
  webServerPort?: string;
}
export interface EventMessage {
  eventName: string;
  data?: any;
  success: boolean;
  code?: number;
}
export interface ActionParser {
  [action: number]: (result: number, data) => EventMessage;
}
export interface FileInfo {
  type: number;
  fullname: string;
}
export enum UploadType {
  FILE,
  DIRECTORY,
}
export interface DownloadInfo {
  names: Array<string>;
  path: string;
  to?: string;
}
export interface ResponseParser {
  [action: string]: (res, result?: number) => EventMessage;
}

export enum ServerError {
  RequestBeforeLogin = 30004, //未登录成功前发送了需要登录后执行的请求
}

export enum ConnectError {
  ProxyTimeout = 30000, //代理服务器连接超时
  Disconnect, //连接断开
  ExecuteTimeout, //命令执行超时
  Closed = 30006, //连接关闭
}
